import { OnInit, ChangeDetectorRef, Component, ContentChild, ElementRef, HostListener, Input, NgModule, ViewChild, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'simple-modal',
    templateUrl: './simple-modal.component.html',
    styleUrls: ['./simple-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SimpleModalComponent implements OnInit {
  @Input() closeOnOutsideClick: boolean  = true;
  @Input() data: any  = {};
  visible: boolean = false;
  visibleAnimate: boolean = false;
  @ContentChild('modalHeader') header;
  @ContentChild('modalBody') body;
  @ContentChild('modalFooter') footer;


  constructor(
    public elementRef: ElementRef,
    public changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    //console.log(this.data)
  }

  ngOnDestroy() {
    // Prevent modal from not executing its closing actions if the user navigated away (for example,
    // through a link).
    this.close();
  }
  /**
   * @return {?}
   */
  open() {
    document.body.classList.add('simple-modal-open');
    this.visible = true;
    setTimeout(() => {
      this.visibleAnimate = true;
    });
  }
  /**
   * @return {?}
   */
  close() {
    document.body.classList.remove('simple-modal-open');
    this.visibleAnimate = false;
    setTimeout(() => {
      this.visible = false;
      this.changeDetectorRef.markForCheck();
    }, 200);
  }
  /**
   * @param {?} event
   * @return {?}
   */
  @HostListener('click', ['$event']) onContainerClicked(event) {
    if (((event.target)).classList.contains('simple-modal') && this.isTopMost() && this.closeOnOutsideClick) {
      this.close();
    }
  }
  /**
   * @param {?} event
   * @return {?}
   */
  @HostListener('document:keydown', ['$event']) onKeyDownHandler(event) {
    // If ESC key and TOP MOST modal, close it.
    if (event.key === 'Escape' && this.isTopMost()) {
      this.close();
    }
  }
  /**
   * Returns true if this modal is the top most modal.
   * @return {?}
   */
  isTopMost() {
    return !this.elementRef.nativeElement.querySelector(':scope simple-modal > .simple-modal');
  }

}
